module.exports = __webpack_public_path__ + "static/media/Rubik-Regular.cd619a4f.ttf";